import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const atLeastOneRequired = (controlNames: string[]): ValidatorFn => {
    return (group: AbstractControl): ValidationErrors | null => {
        if (!group || !group.get) return null;

        const hasValue = controlNames.some((name) => {
            const control = group.get(name);
            const value = control?.value;
            return value && Object.keys(value).length > 0;
        });

        return hasValue ? null : { atLeastOneRequired: true };
    };
};
